import { useTelegram } from './useTelegram';
import { useUser } from '../contexts/UserContext';

export const useUserProfile = () => {
  const { user: telegramUser } = useTelegram();
  const { user } = useUser();
  
  // Get user display name from Telegram data
  const getUserDisplayName = () => {
    if (telegramUser) {
      if (telegramUser.username) {
        return `@${telegramUser.username}`;
      }
      return telegramUser.first_name + (telegramUser.last_name ? ` ${telegramUser.last_name}` : '');
    }
    return user?.username || "User";
  };

  // Get user profile photo from Telegram data
  const getUserPhoto = () => {
    if (telegramUser && telegramUser.photo_url) {
      return telegramUser.photo_url;
    }
    // Fallback avatar if no Telegram photo
    return user?.photoUrl || "https://masterpiecer-images.s3.yandex.net/5fcee00cb9ed068:upscaled";
  };

  return {
    getUserDisplayName,
    getUserPhoto,
    displayName: getUserDisplayName(),
    photo: getUserPhoto()
  };
}; 